import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VListItem,
    {
      attrs: { href: _vm.href, "data-qa": _vm.dataQa },
      on: {
        click: function ($event) {
          return _setup.emit("click")
        },
      },
    },
    [
      _c(VListItemIcon, [_c(VIcon, { class: _vm.icon })], 1),
      _vm._v(" "),
      _c(
        VListItemContent,
        [
          _c(VListItemTitle, { class: _vm.titleClass }, [
            _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
          ]),
          _vm._v(" "),
          _vm.subtitle
            ? _c(VListItemSubtitle, { class: _vm.subtitleClass }, [
                _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }